import getApiClient from '../../../plugins/api'
import updateNavigationRoutes from '../../../containers/_nav'

export default {
    changePage: function(page) {
        this.page = page
    },

    setSearchRole: function(role) {
        this.searchParams.roles = role
    },

    loadUsers: function() {
        const self = this,
            api = getApiClient(self.$store)

        self.$store.commit('startLoading')

        self.searchParams.page = self.page

        api.get('users', {
            params: self.searchParams
        })
            .then((result) => {
                self.users = result.data['hydra:member']
                self.totalPages = Math.ceil(result.data['hydra:totalItems'] / self.perPage)
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    showImpersonateModal: function(id) {
        const self = this
        self.impersonateModal = true
        self.$on('startImpersonating', function() {
            self.impersonate(id)
        })
    },

    hideImpersonateModal: function() {
        this.$refs.impersonateUserModal.hide()
    },

    impersonate: function(id) {
        const self = this,
            api = getApiClient(self.$store)

        api.get(`/user/${id}`)
            .then((result) => {
                let userData = result.data
                self.$store.commit('setImpersonatedUser', userData)
                updateNavigationRoutes()
                location.reload()
            })

    },

    canImpersonate: function(user) {
        if (this.$store.state.user.roles.includes('ROLE_ADMIN')) {
            return true
        }

        if (this.$store.state.user.roles.includes('ROLE_SERVICE')) {
            if (user.roles.includes('ROLE_ADMIN') || user.roles.includes('ROLE_SERVICE')) {
                return false
            } else {
                return true
            }
        }

        return false
    }
}
